import { combineReducers } from 'redux'

import { reducer as apiv3 } from 'data/reducers/apiv3'
import { reducer as routes } from 'lib/api/experiences/routes'
import { reducer as search } from 'lib/api/search'
import { reducer as currentUser } from 'lib/api/currentUser'
import { localeReducer as locale } from 'data/reducers/locale'

export const rootReducer = combineReducers({
  apiv3,
  routes,
  // needed by LoadExisting
  search,
  currentUser,
  locale
})
